import { openSalesIQChat } from '../utils/openSalesIQChat';

const tips = [
  {
    title: 'Back up before big changes',
    text: 'Create a fresh backup before any upgrade or computer move so your tree is always recoverable.',
  },
  {
    title: 'Know your setup',
    text: 'Windows or Mac, plus your FTM version, helps us give you the right steps the first time.',
  },
  {
    title: 'Keep media folders handy',
    text: 'If photos link from local folders, leave those folders in place during restore.',
  },
  {
    title: 'Reach out early',
    text: 'Stuck halfway through an install? Chat before trying random fixes that can make things worse.',
  },
];

export default function GettingStarted() {
  return (
    <section className="t7-section t7-section--wash" id="getting-started">
      <div className="container">
        <div className="grid lg:grid-cols-[1fr_1.1fr] gap-8 lg:gap-12 items-start">
          <div className="t7-head t7-head--rail mb-0">
            <p className="t7-kicker">Before you begin</p>
            <h2 className="t7-title">Smart habits for a smoother setup</h2>
            <p className="t7-lead">
              A little preparation goes a long way—especially when you are working with our support
              team on an install, upgrade, or migration.
            </p>
            <div className="t7-actions">
              <button type="button" className="t7-btn t7-btn--green" onClick={openSalesIQChat}>
                Talk to an Expert
              </button>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4 sm:gap-5">
            {tips.map((tip) => (
              <article
                key={tip.title}
                className="bg-white border border-[#c4d4ca] rounded-[10px] p-4 sm:p-5 hover:border-[#40916c] transition-colors shadow-sm"
              >
                <h3 className="font-serif text-base sm:text-lg text-[#152019] mb-2">{tip.title}</h3>
                <p className="text-sm text-[#55665c] leading-relaxed m-0">{tip.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
